import D2C_ProviderHosting from './Hosting'

class D2C_ProviderAWS extends D2C_ProviderHosting {
  static objectType = 'providerType'
  static active = true
  static order = 12
  static providerType = 'AWS'
  static providerTitle = 'Amazon Web Services'
  static helpLink = 'https://docs.d2c.io/providers/cloud-providers/#amazon-web-services'
  static fields = {
    ...D2C_ProviderHosting.fields,
    accessId: {
      default: '',
      label: 'Access ID',
      path: 'auth.accessId',
      required: true,
      validate(value) {
        return /^[A-Z0-9]{20}$/.test(value) ? null : 'Must contain 20 letters or numbers'
      },
      creating: {},
    },
    secretKey: {
      default: '',
      label: 'Secret key',
      path: 'auth.secretKey',
      required: true,
      validate(value) {
        return /^[A-Za-z0-9/+=]{40}$/.test(value) ? null : 'Must contain 40 letters or numbers'
      },
      creating: {},
    }
  }
}

export default D2C_ProviderAWS
